import { DialogLayout } from './DialogLayout';

// TODO: in v9, move styled() from DialogLayout.jsx to here
export var StyledDialogLayout = DialogLayout;